import type { I18nCountriesLocaleModule } from '@change-corgi/config/i18n/countries/locale-data/common';

export async function getCountries(locale: string): Promise<I18nCountriesLocaleModule> {
	return import(
		/* webpackChunkName: "i18n/countries/locale/[request]" */ `@change-corgi/config/i18n/countries/locale-data/${locale}.js`
	) as Promise<I18nCountriesLocaleModule>;
}
